import Subjects from "../models/subjects";
import StudentList from "./students/student-list";
import StudentTicketStore from "./students/student-ticket-store";
import EditTaskStore from "./task/edit-task";
import NewTaskStore from "./task/new-task";
import TaskFilterStore from "./task/task-filter";
import TaskListStore from "./task/task-list";
import NewTicket from "./ticket/new-ticket";
import TicketBar from "./ticket/ticket-bar";
import TicketList from "./ticket/ticket-list";

export class SubjectContainer {

    //tasks
    taskList: TaskListStore;
    taskFilter: TaskFilterStore;
    newTask: NewTaskStore;
    editTask: EditTaskStore;

    //tickets
    ticketBar: TicketBar;
    newTicket: NewTicket;
    ticketList: TicketList;

    //students
    studentsList: StudentList;
    studentTicket: StudentTicketStore;

    constructor(subject: Subjects) {

        this.taskList = new TaskListStore(subject);
        this.taskFilter = new TaskFilterStore(subject);
        this.newTask = new NewTaskStore(subject);
        this.editTask = new EditTaskStore(subject);

        this.ticketBar = new TicketBar(subject);
        this.newTicket = new NewTicket(subject);
        this.ticketList = new TicketList(subject);

        this.studentsList = new StudentList(subject);
        this.studentTicket = new StudentTicketStore(subject);
    }
}